"use client";

import Image from "next/image";
import React, { useCallback, useEffect, useState } from "react";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Slider } from "@/components/ui/slider";
import * as m from "@/paraglide/messages";

type Props = {};

export default function BentoWeights({}: Props) {
  const [btcWeight, setBtcWeight] = useState(79);
  const [ethWeight, setEthWeight] = useState(12);
  const [solWeight, setSolWeight] = useState(65);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (hover) {
      interval = setInterval(() => {
        setBtcWeight((prev) => (prev > 33 ? prev - 1 : 33));
        setEthWeight((prev) => (prev < 33 ? prev + 1 : 33));
        setSolWeight((prev) => (prev > 33 ? prev - 1 : 33));
      }, 2); // Adjust the interval time for the desired speed
    } else {
      interval = setInterval(() => {
        setBtcWeight((prev) => (prev < 79 ? prev + 1 : 79));
        setEthWeight((prev) => (prev > 12 ? prev - 1 : 12));
        setSolWeight((prev) => (prev < 65 ? prev + 1 : 65));
      }, 5); // Adjust the interval time for the desired speed
    }

    return () => clearInterval(interval);
  }, [hover]);

  const handleMouseEnter = useCallback(() => setHover(true), []);

  const handleMouseLeave = useCallback(() => setHover(false), []);

  return (
    <Card
      className=""
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CardHeader></CardHeader>
      <CardContent>
        <div className="space-y-2">
          <h2 className="text-lg font-bold text-foreground">
            {m.sunny_grassy_cheetah_quell()}
          </h2>
          <p className="text-muted-foreground">{m.short_lost_impala_vent()}</p>
        </div>
        <div className="mt-4 flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <div className="flex items-center gap-2">
                <Image
                  src="/images/marketing/btc.svg"
                  alt="BTC"
                  height={20}
                  width={20}
                />
                <span className="text-sm font-bold">BTC</span>
              </div>
              <div>
                <span className="text-sm font-bold">{btcWeight}%</span>
              </div>
            </div>
            <Slider
              defaultValue={[btcWeight]}
              value={[btcWeight]}
              max={100}
              step={1}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <div className="flex items-center gap-2">
                <Image
                  src="/images/marketing/eth.svg"
                  alt="ETH"
                  height={20}
                  width={20}
                />
                <span className="text-sm font-bold">ETH</span>
              </div>
              <div>
                <span className="text-sm font-bold">{ethWeight}%</span>
              </div>
            </div>
            <Slider
              defaultValue={[ethWeight]}
              value={[ethWeight]}
              max={100}
              step={1}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <div className="flex items-center gap-2">
                <Image
                  src="/images/marketing/sol.svg"
                  alt="SOL"
                  height={20}
                  width={20}
                />
                <span className="text-sm font-bold">SOL</span>
              </div>
              <div>
                <span className="text-sm font-bold">{solWeight}%</span>
              </div>
            </div>
            <Slider
              defaultValue={[solWeight]}
              value={[solWeight]}
              max={100}
              step={1}
            />
          </div>
        </div>
      </CardContent>
      <CardFooter></CardFooter>
    </Card>
  );
}
